import searchHelper from '../search/searchHelper'

const hubFilter = (data) => ({
    ...searchHelper,
    pagination: {
        start: 1,
        stop: 1,
        page: 1,
        step: 5,
        pages: 1,
        previousPages: [],
    },
    hits: 0,
    categories: JSON.parse(decodeURIComponent(data.categories)),
    pages: JSON.parse(decodeURIComponent(data.pages)),
    thisCategory: JSON.parse(decodeURIComponent(data.category)),
    categoryIds: data.searchableCategoryIds,
    filterOptions: [],
    selectedFilters: [],
    pagePool: [],
    visiblePages: [],
    init() {
        if (this.pages.length > 0) {
            // maybe we need to add pages from current category
            const currentCategory = {
                banner: this.thisCategory.banner,
                id_cms_category: this.thisCategory.id_cms_category,
                name: this.thisCategory.name,
                links: [],
            }

            this.pages.forEach((page) => {
                currentCategory.links.push({
                    id_cms: page.id_cms,
                    id_cms_category: this.thisCategory.id_cms_category,
                    link: page.generated_link,
                    title: page.title,
                    parent_link: page.parent_link,
                    parent_name: page.parent_name,
                })
            })

            this.categories.unshift(currentCategory)
        }

        let articleCount = 0

        this.categories.forEach((category) => {
            const filterOption = {
                filter_name: category.name,
                filter_id: category.id_cms_category,
                filter_articles: [],
            }

            const links = []
            category.links.forEach((link) => {
                if (link.id_cms) {
                    articleCount += 1
                    links.push(link)
                    filterOption.filter_articles.push(link)
                }
            })
            category.links = links

            this.filterOptions.push(filterOption)
        })

        this.prepPagination()
        this.prepEntries()
    },
    toggleFilterSelection(filterId) {
        if (this.selectedFilters.includes(filterId)) {
            this.selectedFilters.splice(this.selectedFilters.indexOf(filterId), 1)
        } else {
            this.selectedFilters.push(filterId)
        }

        // A new filter selection starts on the first page. Drop any ?page= left over from the previous
        // selection, otherwise loadProducts() would read it back and open that page of the new results.
        const url = new URL(window.location.href)
        url.searchParams.delete('page')
        window.history.replaceState({}, '', url)

        this.prepPagination()
        this.prepEntries()
    },
    prepEntries() {
        this.pagePool = []
        this.categories.forEach((category) => {
            if (this.selectedFilters.length === 0 || this.selectedFilters.includes(category.id_cms_category)) {
                this.pagePool = [...this.pagePool, ...category.links]
            }
        })
        this.loadProducts(1)
    },
    prepPagination() {
        // filter selection has changed , need to recalc pagination
        let articleCount = 0

        this.categories.forEach((category) => {
            if (this.selectedFilters.length === 0 || this.selectedFilters.includes(category.id_cms_category)) {
                articleCount += category.links.length
            }
        })

        this.pagination.page = 1
        this.hits = articleCount
        this.pagination.pages = Math.ceil(articleCount / this.pagination.step)
        this.pagination.stop = Math.ceil(articleCount / this.pagination.step)
    },
    loadProducts(page) {
        this.loadingProducts = true
        let currentPage = page

        if (this.pagination.page !== this.getCurrentPage()) {
            currentPage = this.getCurrentPage()
        }

        if (page === null) {
            currentPage = this.pagination.page
        }

        this.setCurrentPage(currentPage)

        this.visiblePages = []
        this.pagePool.forEach((visiblePage, index) => {
            if (index >= ((currentPage - 1) * this.pagination.step) && index < (currentPage * this.pagination.step)) {
                this.visiblePages.push(visiblePage)
            }
        })

        this.startIndex = (currentPage - 1) * this.pagination.step + 1 // products shown position start
        this.endIndex = this.hits < currentPage * this.pagination.step ? this.hits : currentPage * this.pagination.step // products shown position end

        this.pagination.start = currentPage - 2
        if (this.pagination.start < 1) { this.pagination.start = 1 }
        this.pagination.stop = currentPage + 2
        if (this.pagination.stop > this.pagination.pages) { this.pagination.stop = this.pagination.pages }
        this.pagination.page = currentPage

        if (currentPage > this.pagination.pages && this.pagination.pages > 0) {
            this.loadProducts(1)
        }

        const previousPagesRange = this.pagination.stop - this.pagination.start + 1
        if (previousPagesRange > 0) {
            this.pagination.previousPages = Array.from(
                Array(previousPagesRange),
                (_, x) => x + this.pagination.start,
            )
        }
    },
})

document.addEventListener('alpine:init', () => {
    window.Alpine.data('hubFilter', hubFilter)
})

export default hubFilter
